import React, { useEffect } from 'react';
import type { PageConfig } from 'c-config';
import { PostAuthRoutes } from 'c-routes';
import { NewCampaignForm } from 'c-main/Components';
import ReactGA from 'react-ga';
import { NewCampaignPagePermissions } from './pagePermissions';

const NewCampaignPage = () => {
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }, []);
    return <NewCampaignForm />;
};

const setup: PageConfig = {
    id: 'NewCampaignPagePage',
    component: NewCampaignPage,
    systemSearch: {
        title: 'Modules.Main.Campaigns.Create.metaTitle',
        description: 'Modules.Main.Campaigns.Create.description',
        type: 'page',
        aliases: 'SystemSearch.aliases.newCampaignPage',
        route: PostAuthRoutes.Campaigns.NewCampaignPage,
        saveAsRecentPage: false,
        breadcrumbs: [
            {
                label: 'Modules.Main.Campaigns.List.metaTitle',
                link: PostAuthRoutes.Campaigns.CampaignList,
            },
            {
                label: 'Modules.Main.Campaigns.Create.metaTitle',
            },
        ],
        permissions: NewCampaignPagePermissions,
    },
};

export default setup;
